import { createSlice, CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { AiUsageResponse } from "@Services/API/Reports";

interface IAiUsageStore {
    data: AiUsageResponse | null;
    isLoading: boolean;
    hasErrors: boolean;
}

const initialState: IAiUsageStore = {
    data: null,
    isLoading: false,
    hasErrors: false,
};

const fetchAiUsageStart: CaseReducer<IAiUsageStore> = (state) => {
    state.isLoading = true;
    state.hasErrors = false;
};

const fetchAiUsageSuccess: CaseReducer<
    IAiUsageStore,
    PayloadAction<AiUsageResponse>
> = (state, { payload }) => {
    state.data = payload;
    state.isLoading = false;
    state.hasErrors = false;
};

const fetchAiUsageFailure: CaseReducer<IAiUsageStore> = (state) => {
    state.isLoading = false;
    state.hasErrors = true;
};

const aiUsageSlice = createSlice({
    name: "aiUsage",
    initialState,
    reducers: {
        fetchAiUsageStart,
        fetchAiUsageSuccess,
        fetchAiUsageFailure,
    },
});

export const { name, actions } = aiUsageSlice;

export default aiUsageSlice.reducer;
